<template>
<div class="menu">
    <moo-menu ref="wikiMenu" active-text-color="#5C70FF" background-color="#FAFAFB" :default-active="`${headerTitle}`" class="moo-menu-vertical" @select="handleSelect">
      <div class="title">
        <img src="@/assets/h5/dir_brand.png" class="title-icon">
        <span>{{$t("管家云文档#!!!#src/pages/CloudHome/components/menu.vue_1")}}</span>
        <svg-icon @click="handleCollapse" class-name="collapse-icon" icon-class="collapse-icon"></svg-icon>
      </div>
      <moo-menu-item index="1">
        <svg-icon v-if="headerTitle != 1" class-name="menu-icon" icon-class="home"></svg-icon>
        <svg-icon v-else class-name="menu-icon" icon-class="home-select"></svg-icon>
        <span slot="title">{{$t("首页#!!!#src/pages/CloudHome/components/menu.vue_1")}}</span>
      </moo-menu-item>
      <moo-menu-item index="5">
        <svg-icon v-if="headerTitle != 5" class-name="menu-icon" icon-class="star"></svg-icon>
        <svg-icon v-else class-name="menu-icon" icon-class="star-select"></svg-icon>
        <span slot="title">{{$t("收藏#!!!#src/pages/CloudHome/components/menu.vue_1")}}</span>
      </moo-menu-item>
      <div class="menu-tip">{{$t("按归属#!!!#src/pages/CloudHome/components/menu.vue_1")}}</div>
      <moo-menu-item index="2">
        <svg-icon v-if="headerTitle != 2" class-name="menu-icon" icon-class="my"></svg-icon>
        <svg-icon v-else class-name="menu-icon" icon-class="my-select"></svg-icon>
        <span slot="title">{{$t("我的文档#!!!#src/pages/CloudHome/components/menu.vue_1")}}</span>
      </moo-menu-item>
      <moo-menu-item index="3">
        <template slot="title">
          <div class="wiki-item">
            <div class="wiki-title-info">
              <svg-icon v-if="headerTitle != 3" class-name="menu-icon" icon-class="wiki"></svg-icon>
              <svg-icon v-else class-name="menu-icon" icon-class="wiki-select"></svg-icon>
              <span slot="title">{{$t("知识库#!!!#src/pages/CloudHome/components/menu.vue_1")}}</span>
            </div>
          </div>
        </template>
      </moo-menu-item>
    </moo-menu>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Menu",
  components: {},
  data() {
    return {
      collapse: true
    };
  },
  methods: {
    ...mapActions({
      setCollapse: "setCollapse",
      setHeaderTitle: "setHeaderTitle",
    }),
    handleCollapse() {
      this.setCollapse(true);
    },
    handleSelect(key) {
      this.setHeaderTitle(key);
      if (key == 1) window.location.hash = "";
      if (key == 2) window.location.hash = "my";
      if (key == 3) window.location.hash = "wiki";
      if (key == 5) window.location.hash = "star";
    },
  },
  computed: {
    ...mapState({
      headerTitle: (state) => state.headerTitle
    })
  },
};
</script>

<style lang="scss">
::-webkit-scrollbar {
  display: none;
}

.menu {
  flex-shrink: 0;
  height: 100%;
  background: #fafafb;
  box-shadow: inset -1px 0 0 0 #e8e9eb;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 8px;
  width: 210px;

  .moo-menu-vertical {
    border: none;

    .title {
      display: flex;
      flex-flow: row;
      padding: 16px 14px;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;

      .title-icon {
        width: 26px;
        height: 26px;
        background: #5c70ff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;

        // .title-icon {
        //   width: 16px;
        //   height: 16px;
        // }
      }

      span {
        flex: 1;
      }

      .collapse-icon {
        cursor: pointer;
        width: 16px;
        height: 16px;
      }
    }

    .menu-tip {
      margin: 16px 0 8px 0;
      padding: 0 8px;
      box-sizing: border-box;
      font-size: 12px;
      font-weight: 400;
      color: #a2a4b0;
    }

    .is-opened,
    .wiki-menu-item {
      background: #e7eaff !important;

      .moo-submenu__title {
        color: #5c70ff;
      }
    }

    .moo-submenu__title {
      width: 100%;
      height: 100%;
      background: transparent !important;
      line-height: unset !important;
      padding: 0 0 0 16px !important;
      display: flex;
      flex-flow: row;
      align-items: center;
    }

    .moo-menu--inline {
      margin-top: 4px !important;
    }

    .moo-menu-item-group {
      ul {
        li {
          width: 100%;
          padding: 0 0 0 42px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
        }
      }

      .is-active {
        color: unset !important;
        background: unset !important;
      }
    }

    .moo-menu-item-group__title {
      display: none;
    }

    .wiki-item {
      position: relative;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;

      .wiki-title-info {
        position: relative;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: center;

        .review-view {
          position: absolute;
          width: 64px;
          height: 15px;
          top: 0px;
        }
      }
    }

    .wiki-menu-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 16px;
      margin: auto 0;
      line-height: 3;
      font-size: 12px;
      color: #656b74 !important;

      &:hover {
        &::before {
          background: #e4e4e6;
        }
      }
    }

    .moo-menu-item {
      padding: 0 0 0 16px !important;
      border-radius: 8px;
      height: 36px;
      line-height: 36px;
      margin-bottom: 4px;
      font-weight: 400;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: flex-start;
      color: #222329;

      &:hover {
        background: #eeeff1 !important;
      }

      .menu-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }

    .is-active {
      &:hover {
        background: #e7eaff !important;
      }
      background: #e7eaff !important;
    }
  }
}
</style>
